import axios from "axios";
import store from '../store';

// DEV
//const BASE_URL = "http://127.0.0.1:4000/";

// const BASE_URL = "http://10.3.99.159:32247/";
// const ELASTIC_SEARCH_BASE_URL = 'http://10.3.99.159:32681/';

// const BASE_URL = "https://10.3.100.52:30998/";
// const ELASTIC_SEARCH_BASE_URL = 'http://10.3.99.159:32681/';

const BASE_URL = process.env.VUE_APP_BASE_URL;
const ELASTIC_SEARCH_BASE_URL = process.env.VUE_APP_ELASTIC_SEARCH_BASE_URL;

export default {
    async publicPost(url, body){
        return axios({
            method: 'post',
            headers: {
                'Access-Control-Allow-Origin': '*'
            },
            url: `${BASE_URL}${url}`,
            data: body
        }).then(resp => {
            return resp.data;
        }).catch((e) => {
            return {
                success: false,
                data: e.response.data.data
            }
        });
    },
    
    async loginPost(url, body){
        return axios({
            method: 'post',
            headers: {
                'Access-Control-Allow-Origin': '*'
            },
            url: `${BASE_URL}${url}`,
            data: body
        }).then(resp => {
            return resp.data;
        }).catch((e) => {
            return {
                success: false,
                data: e.response.data
            }
        });
    },
    async get(url, params){
        return axios({
            method: 'get',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            params: params,
            url: `${BASE_URL}${url}`
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){
                return e.response.data
            }
            return {
                success: false
            }
        });
    },
    async getElasticSearch(query){

        let data = {
            query: {
                regexp: {
                    index: {
                        value: query,
                        flags: 'ALL',
                        case_insensitive: true,
                        max_determinized_status: 10000,
                        rewrite: 'constant_core'
                    }
                }
            }
        }

        return axios({
            method: 'get',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            data: data,
            url: `${ELASTIC_SEARCH_BASE_URL}smartsim/_search`
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            return {
                success: false
            }
        });
    },
    async getItem(url, id){
        return axios({
            method: 'get',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: `${BASE_URL}${url}/${id}`
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            return {
                success: false,
                message: "Si è verificato un errore"
            }
        });
    },
    async post(url, body){
        return axios({
            method: 'post',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: `${BASE_URL}${url}`,
            data: body
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let errorData= e.response.data.errorMessage.data;
                if(errorData){
                    for(let i=0; i<errorData.length; i++){
                        errorMessage +=errorData[i].value;
                        errorMessage +="\n";
                    }

                    return {
                        success: false,
                        message: errorMessage
                    }    
                }else if(e.response.data.data){
                    for(let i=0; i<e.response.data.data.length; i++){
                        errorMessage +=e.response.data.data[i].value;
                        errorMessage +="\n";
                    }

                    return {
                        success: false,
                        message: errorMessage
                    }    
                }else{
                    return {
                        success: false,
                        message: e.response.data.errorMessage
                    }   
                }
                
            }
            return e.response.data.errorMessage;
        });
    },
    async postWToken(url, token, body){
        return axios({
            method: 'post',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + token
            },
            url: `${BASE_URL}${url}`,
            data: body
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let errorData= e.response.data.errorMessage.data;
                if(errorData){
                    for(let i=0; i<errorData.length; i++){
                        errorMessage +=errorData[i].value;
                        errorMessage +="\n";
                    }

                    return {
                        success: false,
                        message: errorMessage
                    }    
                }else if(e.response.data.data){
                    for(let i=0; i<e.response.data.data.length; i++){
                        errorMessage +=e.response.data.data[i].value;
                        errorMessage +="\n";
                    }

                    return {
                        success: false,
                        message: errorMessage
                    }    
                }else{
                    return {
                        success: false,
                        message: e.response.data.errorMessage
                    }   
                }
                
            }
            return e.response.data.errorMessage;
        });
    },
    async postId(url, id){
        let completeUrl = `${BASE_URL}${url}/${id}`;
        return axios({
            method: 'post',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: completeUrl
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let  errorData= e.response.data.errorMessage.data;
                if(errorData){
                    for(let i=0; i<errorData.length; i++){
                        errorMessage +=errorData[i].value;
                        errorMessage +="\n";
                    }

                    return {
                        success: false,
                        message: errorMessage
                    }    
                }else{
                    return {
                        success: false,
                        message: e.response.data.errorMessage
                    }   
                }
                
            }
            return e.response.data.errorMessage;
        });
    },
    async put(url, body, id='id'){
        let completeUrl = `${BASE_URL}${url}/${body[id]}`;

        return axios({
            method: 'put',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: completeUrl,
            data: body
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let  errorData= e.response.data.errorMessage.data;
                if(errorData){
                    for(let i=0; i<errorData.length; i++){
                        errorMessage +=errorData[i].value;
                        errorMessage +="\n";
                    }

                    return {
                        success: false,
                        message: errorMessage
                    }    
                }else{
                    return {
                        success: false,
                        message: e.response.data.errorMessage
                    }   
                }   
            }
            return e.response.data.errorMessage;
        });
    },
    async putNoId(url, body){
        let completeUrl = `${BASE_URL}${url}`;

        return axios({
            method: 'put',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: completeUrl,
            data: body
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let  errorData= e.response.data.errorMessage.data;
                if(errorData){
                    for(let i=0; i<errorData.length; i++){
                        errorMessage +=errorData[i].value;
                        errorMessage +="\n";
                    }

                    return {
                        success: false,
                        message: errorMessage
                    }    
                }else{
                    return {
                        success: false,
                        message: e.response.data.errorMessage
                    }   
                }   
            }
            return e.response.data.errorMessage;
        });
    },
    async putOnlyId(url, body, id='id'){
        let completeUrl = `${BASE_URL}${url}/${body[id]}`;

        return axios({
            method: 'put',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: completeUrl,
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let errorData = e.response.data.errorMessage.data;
                for(let i=0; i<errorData.length; i++){
                    errorMessage +=errorData[i].value;
                    errorMessage +="\n";
                }

                return {
                    success: false,
                    message: errorMessage
                }    
            }
            return e.response.data.errorMessage;
        });
    },
    async putQueryParams(url, body){
        let completeUrl = `${BASE_URL}${url}`;

        return axios({
            method: 'put',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            params: body,
            url: completeUrl,
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let errorData = e.response.data.errorMessage.data;
                for(let i=0; i<errorData.length; i++){
                    errorMessage +=errorData[i].value;
                    errorMessage +="\n";
                }

                return {
                    success: false,
                    message: errorMessage
                }    
            }
            return e.response.data.errorMessage;
        });
    },
    async delete(url, id){
        return axios({
            method: 'delete',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: `${BASE_URL}${url}/${id}`
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let errorData = e.response.data.errorMessage.data;
                for(let i=0; i<errorData.length; i++){
                    errorMessage +=errorData[i].value;
                    errorMessage +="\n";
                }

                return {
                    success: false,
                    message: errorMessage
                }    
            }
            return e.response.data.errorMessage;
        });
    },
    async deleteGeneric(url){
        return axios({
            method: 'delete',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: `${BASE_URL}${url}`
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let errorData = e.response.data.errorMessage.data;
                for(let i=0; i<errorData.length; i++){
                    errorMessage +=errorData[i].value;
                    errorMessage +="\n";
                }

                return {
                    success: false,
                    message: errorMessage
                }    
            }
            return e.response.data.errorMessage;
        });
    },
    async deleteWToken(url, token, id){
        return axios({
            method: 'delete',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + token
            },
            url: `${BASE_URL}${url}/${id}`
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let errorData = e.response.data.errorMessage.data;
                for(let i=0; i<errorData.length; i++){
                    errorMessage +=errorData[i].value;
                    errorMessage +="\n";
                }

                return {
                    success: false,
                    message: errorMessage
                }    
            }
            return e.response.data.errorMessage;
        });
    },
    async deleteBody(url, id, body){
        return axios({
            method: 'delete',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            data: body,
            url: `${BASE_URL}${url}/${id}`
        }).then(resp => {
            return resp.data;
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            if(e.response.status == 400){

                let errorMessage = "";
                let errorData = e.response.data.errorMessage.data;
                for(let i=0; i<errorData.length; i++){
                    errorMessage +=errorData[i].value;
                    errorMessage +="\n";
                }

                return {
                    success: false,
                    message: errorMessage
                }    
            }
            return e.response.data.errorMessage;
        });
    },
    async dowloadFile(url, params){
        return axios({
            method: 'get',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            params: params,
            url: `${BASE_URL}${url}`,
            responseType: 'blob'
        }).then((res) => {
            if(res.status == 200){
                return {
                    success: true,
                    ...res
                };
            }else if(res.status == 204){
                return {
                    success: false,
                    message: 'error'
                }
            }else{
                return {
                    success: false
                }
            }
            
            
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            return {
                success: false
            }
        });
    },
    async dowloadFilePathVariable(url, id){
        return axios({
            method: 'get',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.state.security.user.token
            },
            url: `${BASE_URL}${url}/${id}`,
            responseType: 'blob'
        }).then((res) => {
            if(res.status == 200){
                return {
                    success: true,
                    ...res
                };
            }else{
                return {
                    success: false
                }
            }
            
            
        }).catch(e => {
            if(e.response.status == 401){
                store.dispatch('security/logout');
                location.reload();
                return;
            }
            return {
                success: false
            }
        });
    },
    async uploadFile(url, formData){
        return axios.post( `${BASE_URL}${url}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': 'Bearer ' + store.state.security.user.token,
                }
            }
            )
            .then(resp => {
                return resp.data;
            })
            .catch(e => {
                if(e.response.status == 401){
                    store.dispatch('security/logout');
                    location.reload();
                    return;
                }
                if(e.response.status == 400){
    
                    let errorMessage = "";
                    let errorData = e.response.data.errorMessage.data;
                    for(let i=0; i<errorData.length; i++){
                        errorMessage +=errorData[i].value;
                        errorMessage +="\n";
                    }
    
                    return {
                        success: false,
                        message: errorMessage
                    }    
                }
                return e.response.data.errorMessage;
            });
    },  
} 

